import { dimensions, widths, colors, breakpoints } from './variables'
import { media } from './mixins'

export const theme = {
  dimensions,
  widths,
  colors,
  media,
  breakpoints,
}

export interface ThemeInterface extends Readonly<typeof theme> {}



// WEBPACK FOOTER //
// ./src/styles/theme.ts